import { GetCurrentUser200 } from '@platform/client/schemas';
import { ReactElement } from 'react';
import { COHORT_NAMES, PLAN_NAMES, PLAN_PARTNER_NAMES } from '../constants';
import { LumenDashboardLogo, PhilipsDashboardLogo } from '../dashboard/home/logos/DashboardLogos';
// Note that it seems the TSH plan actually does have the Transform logo as its planPartnerLogo. But,
// for some reason the legacy app hardcodes the image from S3 for TSH plans
const TRANSFORM_PLAN_LOGO =
  'https://s3.amazonaws.com/assets.movingworlds.org/images/logos/partners/transform_logo.png';

const getDashboardSubHeaderText = (user: GetCurrentUser200 | undefined) => {
  let navLogo: string | ReactElement | null = null;
  let navText: string | null = null;
  let cohortUrl: string | null = null;
  let cohortDisplayName: string | null = null;

  if (!user) {
    return {
      navLogo,
      navText,
      cohortUrl,
      cohortDisplayName,
    };
  }

  if (
    user.accountType === 'experteer' &&
    user.cohort &&
    user.cohort.displayName !== COHORT_NAMES.EVERGREEN
  ) {
    cohortUrl = user.cohort.url ?? null;
    cohortDisplayName = user.cohort.displayName ?? null;
  }

  // TODO: Do we need to modify this still now that the legacy app is removed?
  // if (!cohortUrl?.startsWith('http')) {
  //   cohortUrl = `${import.meta.env['VITE_LEGACY_APP_URL']}${cohortUrl}`;
  // }

  if (
    (user.accountType === 'experteer' && user.professionalType === 'f5') ||
    user.corporatePartner === PLAN_PARTNER_NAMES.F5
  ) {
    navLogo = user.corporatePartnerLogo;
    navText = 'F5 Volunteer Sprint';
  } else if (user.accountType === 'experteer' && user.professionalType === 'lumen') {
    navLogo = <LumenDashboardLogo />;
    navText = 'Volunteer Sprint';
  } else if (user.accountType === 'experteer' && user.professionalType === 'reckitt') {
    navLogo = user.corporatePartnerLogo;
    navText = 'Accelerate Hub';
  } else if (user.accountType === 'experteer' && user.professionalType === 'philips') {
    navLogo = <PhilipsDashboardLogo />;
    navText = 'Philips Foundation Skilled Volunteering';
  } else if (
    (user.accountType === 'experteer' && user.professionalType === 'tsh') ||
    (user.accountType === 'organization' && user.organization?.applicationStatus === 'approved') ||
    (user.accountType === 'organization' &&
      user.organization?.partners.find((partner) => partner.name === PLAN_NAMES.TRANSFORM))
  ) {
    navLogo = TRANSFORM_PLAN_LOGO;
    navText = 'TRANSFORM Support Hub';
  }

  return {
    navLogo,
    navText,
    cohortUrl,
    cohortDisplayName,
  };
};

export default getDashboardSubHeaderText;
